import { getEKPUrl, isMyEasybellCom } from '@/utils/environment'
import { toNumber } from '@/utils/parsing'

export function getMyEasybellComUpgradeUrl() {
  return `${getMyEasybellComSubscriptionManagementUrl()}`
}

export function getMyEasybellComSubscriptionManagementUrl() {
  return `https://my.easybell.com/subscription-management`
}

export function getCtaSubscriptionManagementUrl() {
  return `${getEKPUrl()}/subscription-management/cta`
}

export function getUpsellSubscriptionManagementUrl() {
  return isMyEasybellCom()
    ? getMyEasybellComUpgradeUrl()
    : getCtaSubscriptionManagementUrl()
}

export function redirectGermanPlanChange() {
  if (isMyEasybellCom()) return false

  window.location.href = getCtaSubscriptionManagementUrl()
  return true
}

export function redirectUpsellToSubscriptionManagement() {
  window.open(
    getUpsellSubscriptionManagementUrl(),
    '_blank',
    'noopener,noreferrer'
  )
}

const maxRedirects = 3

const redirectCountKey = 'redirectCount'

function getRedirectCount() {
  const url = new URL(window.location.href)

  return toNumber(url.searchParams.get(redirectCountKey)) ?? 0
}

export function hasReachedMaxRedirects() {
  return getRedirectCount() >= maxRedirects
}

export function getEkpLoginWithRedirectUrl() {
  const redirectUrl = new URL(window.location.href)

  // Remove the "auth" and "customerId" query params
  ;['auth', 'customerId'].forEach((key) => redirectUrl.searchParams.delete(key))

  // Increase redirect count by 1
  redirectUrl.searchParams.set(redirectCountKey, String(getRedirectCount() + 1))

  // Avoid redirecting back to /login and /logout, redirect to the overview page instead
  if (['/login', '/logout'].includes(redirectUrl.pathname)) {
    redirectUrl.pathname = ''
  }

  return `${getEKPUrl()}/login?login_type=cta&redirect=${redirectUrl.href}`
}
